/**
 * @fileoverview gRPC-Web generated client stub for registry
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.19.1
// source: weber.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');

const proto = {};
proto.registry = require('./weber_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.registry.WeberServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.registry.WeberServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.registry.UserDataRequest,
 *   !proto.registry.UserDataResponse>}
 */
const methodDescriptor_WeberService_GetUserData = new grpc.web.MethodDescriptor(
  '/registry.WeberService/GetUserData',
  grpc.web.MethodType.UNARY,
  proto.registry.UserDataRequest,
  proto.registry.UserDataResponse,
  /**
   * @param {!proto.registry.UserDataRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.registry.UserDataResponse.deserializeBinary
);


/**
 * @param {!proto.registry.UserDataRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.registry.UserDataResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.registry.UserDataResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.registry.WeberServiceClient.prototype.getUserData =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/registry.WeberService/GetUserData',
      request,
      metadata || {},
      methodDescriptor_WeberService_GetUserData,
      callback);
};


/**
 * @param {!proto.registry.UserDataRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.registry.UserDataResponse>}
 *     Promise that resolves to the response
 */
proto.registry.WeberServicePromiseClient.prototype.getUserData =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/registry.WeberService/GetUserData',
      request,
      metadata || {},
      methodDescriptor_WeberService_GetUserData);
};


module.exports = proto.registry;

